import type { ThemeToggleTranslations } from "./pl";

export const en: ThemeToggleTranslations = {
  themeName: {
    light: "light",
    dark: "dark",
    funeral: "mourning",
    hc: "high contrast",
  },
  tooltip: (name) => `Theme: ${name} (click to change)`,
  ariaLabel: (name) => `Change theme, current: ${name}`,
};
